<template>
<div>
   <span id="toggleFilterPanel" class="ms-Button">
        <span class="ms-Button-label">{{ buttonText }}</span>
    </span>
    <em id="shownLetTypes">{{ filteredStatusText }}</em>
    <br />
</div>
</template>

<script>
export default {
  name: 'DivisionFilterButton',
  data: function() {
         return  {
           buttonText:"Filter Let Type",
           filteredStatusText:"Showing all Advertised or Antcipated Lets."
         }
  }
}
</script>